import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  type TooltipVariant,
} from "visuais";
import React from "react";

export function Tooltiper({
  children,
  content,
  align = "center",
  variant = "default",
  side,
  sideOffset,
  ...props
}: {
  children: React.ReactNode;
  content: React.ReactNode;
  align?: "center" | "start" | "end";
  variant?: TooltipVariant;
  side?: "top" | "right" | "bottom" | "left";
  sideOffset?: number;
  // ...outros props se quiser
}) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          className="border-1 text-[8pt]"
          align={align}
          variant={variant}
          side={side}
          sideOffset={sideOffset}
          {...props}
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
